import { Component, OnInit } from '@angular/core';
import { StoreService } from '../../services/store.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'thank-you',
  templateUrl: './thank-you.component.html',
  styleUrls: ['./thank-you.component.scss']
})
export class ThankYouComponent implements OnInit {

  safeHtml!: SafeHtml;

  constructor(public storeService: StoreService, private sanitizer: DomSanitizer) { }

  ngOnInit() {
    const decoded = this.decodeHtmlEntitiesRepeatedly(this.storeService.kioskSettings.thankYouPageText);
    this.safeHtml = this.sanitizer.bypassSecurityTrustHtml(decoded);
  }

  private decodeHtmlEntitiesRepeatedly(input: string): string {
    const textarea = document.createElement('textarea');
    let prev: string;
    let curr = input;
    do {
      prev = curr;
      textarea.innerHTML = curr;
      curr = textarea.value;
    } while (curr !== prev);
    return curr;
  }

}
